import { render, staticRenderFns } from "./description.vue?vue&type=template&id=2e32d919&scoped=true"
import script from "./description.vue?vue&type=script&setup=true&lang=js"
export * from "./description.vue?vue&type=script&setup=true&lang=js"
import style0 from "./description.vue?vue&type=style&index=0&id=2e32d919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e32d919",
  null
  
)

export default component.exports